import { useMemo } from 'react';
import Helmet from '../lib/Helmet';
import { CATALOGUE } from '../data/catalogue';
import { PRICES, STOCK } from '../data/pricing';
import { SERIES } from '../data/highlights';
import { pickGuideModels, usedSources } from '../data/guideInverter';
import { roomNeed, answerFor } from '../data/acCalculatorContent';
import { ENGINE, UNITS } from '../lib/acRecommend';
import { SIZE_SEO, SIZE_UPDATED, SIZE_SOURCES, sizeData, sizeContent } from '../data/guideSize';
import { GuideHeader, GuideBody } from '../components/guide/GuideParts';
import SizeRoom from '../components/guide/SizeRoom';

// Route: /blog/what-size-ac-do-i-need — AC guide 8 (29 Oct 2026). Every word
// comes from sizeContent() in data/guideSize.js, and every size from the AC
// calculator's own engine (ENGINE, UNITS), which scripts/guide-pages.js
// runs too.

export default function SizeGuide() {
  const { c, S } = useMemo(() => {
    const pick = (size) => pickGuideModels({ catalogue: CATALOGUE, prices: PRICES, stock: STOCK, series: SERIES, size });
    const d = sizeData({ roomNeed, answerFor }, ENGINE, UNITS, CATALOGUE);
    const content = sizeContent(d, pick('1.5').five, pick('1.8').three);
    return { c: content, S: usedSources(SIZE_SOURCES, content) };
  }, []);

  return (
    <>
      <Helmet>
        <title>{SIZE_SEO.title}</title>
        <meta name="description" content={SIZE_SEO.meta} />
        <meta property="og:title" content={SIZE_SEO.title} />
        <meta property="og:description" content={SIZE_SEO.meta} />
      </Helmet>
      <main className="bg-white pb-16 pt-16 lg:pt-20">
        <article className="mx-auto max-w-[760px] px-4 text-base leading-relaxed text-gray-900">
          <GuideHeader seo={SIZE_SEO} updated={SIZE_UPDATED} crumb={SIZE_SEO.crumb} />
          <GuideBody c={c} sources={S} current="what-size-ac-do-i-need" ctaSource="guide_size"
            ctaTitle="Not sure which size fits your room?"
            watch={<SizeRoom watch={c.watch} sources={S} />} />
        </article>
      </main>
    </>
  );
}
